export const isStaff = "staff";
export const isExternalUser = "external-user";
export const noIngredientsPage = "no-ingredients-page";
export const platform = "platform";
